import { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { skeletIcon } from '../../assets';
import { MatrixClient } from '../../generated/mlmbox/client/matrix/MatrixServiceClientPb';
import * as mlmbox_client_network_network_pb from '../../generated/mlmbox/client/network/network_pb';
import { NetworkClient } from '../../generated/mlmbox/client/network/NetworkServiceClientPb';
import * as mlmbox_types_account_pb from '../../generated/mlmbox/types/account_pb';
import Ava from '../Common/Ava/Ava';
import Title from '../Title/Title';

import * as mlmbox_types_sort_pb from '../../generated/mlmbox/types/sort_pb';
import { TRootState } from '../../store/store';
import { API_URL } from '../../utils/constants';
import { getColor, getLoginOrId, getToken, haptic, Haptick, PositionNode, setAvas, ViewState } from '../../utils/helper';
// import './Areas.scss';

import { TreeNodes } from '../../pages/Areas/Components/TreeNodes';
import ShortProfile from '../Common/ShortProfile/ShortProfile';
import Modal from '../Modal/Modal';
import UserProfile from '../UserProfile/UserProfile';
const Matrix: FC<{ positionIdView: number; treeId: number }> = ({ positionIdView, treeId }) => {
    const { t } = useTranslation();

    const accId = useSelector((state: TRootState) => state.user.value.info.account.id);
    const schemes = useSelector((state: TRootState) => state.schemes.value);
    const treeAccountsList = useSelector((state: TRootState) => state.user.value.treeAccountsList);

    const [fetching, setFetching] = useState<boolean>(true);

    const [tree, setTree] = useState<PositionNode | undefined>();
    const [money, setMoney] = useState(1);
    const [moneyActive, setMoneyActive] = useState(true);
    const { positionSend } = useParams();
    const [prevPositionId, setPrevPositionId] = useState<number>();
    const [viewPositionId, setViewPositionId] = useState<number>(positionIdView);
    const [positionId, setPositionId] = useState<number | null>(null);

    const [userView, setUserView] = useState<mlmbox_types_account_pb.Account.Info.AsObject | null>();
    const [shortInfo, setShotInfo] = useState<mlmbox_client_network_network_pb.TeamResponse.AsObject | null>();
    const [info, setInfo] = useState<mlmbox_types_account_pb.Account.Info.AsObject | null>();
    const [userInfoOpen, setUserInfoOpen] = useState(false);

    const [matrixView, setMatrixView] = useState<mlmbox_types_account_pb.Matrix.View.AsObject>();
    const [positionIdList, setPositionIdList] = useState<mlmbox_types_account_pb.TreeAccount.Entity.AsObject[]>([]);

    const pag = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (fetching && positionIdView) {
            setShotInfo(null);
            setInfo(null);
            const matrixClient = new MatrixClient(API_URL, null, null);
            const matrixRequest = new mlmbox_types_account_pb.PositionView.Team();

            matrixRequest.setViewPositionId(viewPositionId);

            matrixRequest.setViewLevel(2);

            matrixClient.view(matrixRequest, { authorization: getToken() }, async (err, res) => {
                if (!err) {
                    setMatrixView(res?.toObject());
                    res.toObject().positionsList.forEach((el) => {
                        res.toObject().accountsList.forEach((account) => {
                            if (el.positionId === res.toObject().viewPositionId) {
                                if (res.toObject().viewPositionId !== res.toObject().selfPositionId) {
                                    setPrevPositionId(el.positionRefId);
                                } else {
                                    setPrevPositionId(0);
                                }

                                if (el.accountId === account.account?.id) setUserView(account);
                            }
                        });
                    });

                    const info = res.toObject().accountsList;
                    if (info) await setAvas(info);

                    setPositionIdList(res.toObject().viewTreeAccountEntitiesList);
                    setMoneyActive(true);
                }
            });
        }
    }, [fetching, accId, viewPositionId]);

    useEffect(() => {
        if (userView && userView.account) {
            const accClient = new NetworkClient(API_URL, null, null);
            const req = new mlmbox_client_network_network_pb.TeamRequest();
            const sort = new mlmbox_types_sort_pb.Sort();
            sort.setLimit(10);
            sort.setDirection(mlmbox_types_sort_pb.Sort.Direction.BACKWARD);
            req.setFilterTreeIdsBitMask(0);
            const ids = new mlmbox_types_account_pb.Account.Id();
            ids.setAccountId(userView.account?.id);
            req.setViewPartner(ids);
            req.setPartnersSort(sort);

            accClient.teamInfo(req, { authorization: getToken() }, async (err, res) => {
                // console.log(err, res.toObject());
                if (!err) {
                    const info = res.toObject();
                    if (info) {
                        await setAvas(info.partnersList);
                        await setAvas(info.referralsList);
                    }
                    setShotInfo(res.toObject());
                } else {
                    setInfo(userView);
                }

                setFetching(false);
            });
        }
    }, [userView]);

    useEffect(() => {
        if (matrixView?.positionsList.length) {
            // const tree = fillTree(matrixView, position);

            const view = new ViewState();

            schemes.treeGroupsList.forEach((el) => {
                view.addGroup({ title: el.title, id: el.id });
            });
            schemes.treesList.forEach((el) => {
                view.addTree({
                    amountValue: String(el.amount?.value),
                    groupId: el.groupId,
                    title: el.title,
                    defaultPositionWidth: el.defaultPositionWidth,
                    id: el.id,
                    amountAssetId: Number(el.amount?.assetId),
                });

                view.addGroup({ id: el.id, title: el.title });
            });

            matrixView.positionsList.forEach((el) => {
                matrixView.accountsList.forEach((account) => {
                    if (el.accountId === account.account?.id) {
                        view.addPosition({
                            positionId: el.positionId,
                            positionRefId: el.positionRefId,
                            positionRefLine: el.positionRefBranch,
                            positionWidth: el.positionWidth,
                            accountId: Number(el.accountId),
                            treeAccountId: el.accountId,
                            ava: account.profile?.ava,
                            relationship: account.relationship,
                        });
                    }
                });

                //;
            });

            setTree(viewPositionId ? view.cacheView(money, Number(viewPositionId), 2) : view.cacheView(money, Number(positionId), 2));
        }
    }, [matrixView]);

    return (
        <>
            <div
                className="areas1"
                id="section">
                <Title text={t('matrix.titleOne') + ' P' + treeId} />

                <div className="area1">
                    <div className="area1__main">
                        {fetching ? (
                            <div className="load">
                                <div className="spinner"></div>
                            </div>
                        ) : (
                            <>
                                <div className="circle-group">
                                    {tree && (
                                        <TreeNodes
                                            setViewPosotionId={setViewPositionId}
                                            setFetching={setFetching}
                                            matrix={true}
                                            node={tree}
                                        />
                                    )}
                                    <img
                                        className="skelet"
                                        src={skeletIcon}
                                        alt=""
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    <div className="partner">
                        <div className="inner">
                            <div className="avatar">
                                {(prevPositionId && shortInfo && !fetching) || (prevPositionId && info && !fetching) ? (
                                    <div
                                        className="icon"
                                        onClick={() => {
                                            if (fetching) return;
                                            setUserInfoOpen(true);
                                        }}>
                                        <svg
                                            width="23"
                                            height="22"
                                            viewBox="0 0 23 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M6.2679 0.249985H16.7321C17.5449 0.249978 18.2006 0.249972 18.7315 0.293349C19.2781 0.338011 19.7582 0.43237 20.2025 0.658711C20.9081 1.01824 21.4817 1.59191 21.8413 2.29752C22.0676 2.74174 22.162 3.22188 22.2066 3.76852C22.25 4.29942 22.25 4.95503 22.25 5.76786V16.2321C22.25 17.0449 22.25 17.7005 22.2066 18.2315C22.162 18.7781 22.0676 19.2582 21.8413 19.7024C21.4817 20.4081 20.9081 20.9817 20.2025 21.3413C20.0468 21.4206 19.8858 21.4842 19.7174 21.5352C19.0069 21.7505 18.0935 21.7503 16.8363 21.75C16.7913 21.75 16.7459 21.75 16.7 21.75H6.3C6.25412 21.75 6.20868 21.75 6.16368 21.75C4.90651 21.7503 3.99309 21.7505 3.28256 21.5352C3.11424 21.4842 2.95325 21.4206 2.79754 21.3413C2.09193 20.9817 1.51825 20.4081 1.15873 19.7024C0.932385 19.2582 0.838026 18.7781 0.793364 18.2315C0.749987 17.7005 0.749993 17.0449 0.75 16.2321V5.76788C0.749993 4.95504 0.749987 4.29943 0.793364 3.76852C0.838026 3.22188 0.932385 2.74174 1.15873 2.29752C1.51825 1.59191 2.09193 1.01824 2.79754 0.658711C3.24175 0.43237 3.7219 0.338011 4.26853 0.293349C4.79944 0.249972 5.45506 0.249978 6.2679 0.249985ZM4.39068 1.78837C3.9368 1.82545 3.67604 1.89458 3.47852 1.99522C3.05516 2.21094 2.71095 2.55514 2.49524 2.97851C2.3946 3.17602 2.32547 3.43679 2.28838 3.89067C2.25058 4.3533 2.25 4.94753 2.25 5.79999V16.2C2.25 17.0524 2.25058 17.6467 2.28838 18.1093C2.32547 18.5632 2.3946 18.8239 2.49524 19.0215C2.57533 19.1787 2.67314 19.3249 2.78614 19.4578C2.7992 19.3221 2.81699 19.1954 2.84127 19.0733C3.21608 17.189 4.68904 15.7161 6.57332 15.3413C7.03323 15.2498 7.56665 15.2499 8.40471 15.25C8.43604 15.25 8.4678 15.25 8.5 15.25H14.5C14.5322 15.25 14.564 15.25 14.5953 15.25C15.4334 15.2499 15.9668 15.2498 16.4267 15.3413C18.311 15.7161 19.7839 17.189 20.1587 19.0733C20.183 19.1954 20.2008 19.3221 20.2139 19.4578C20.3269 19.3249 20.4247 19.1787 20.5048 19.0215C20.6054 18.8239 20.6745 18.5632 20.7116 18.1093C20.7494 17.6467 20.75 17.0524 20.75 16.2V5.79999C20.75 4.94753 20.7494 4.3533 20.7116 3.89067C20.6745 3.43679 20.6054 3.17602 20.5048 2.97851C20.289 2.55514 19.9448 2.21094 19.5215 1.99522C19.324 1.89458 19.0632 1.82545 18.6093 1.78837C18.1467 1.75057 17.5525 1.74999 16.7 1.74999H6.3C5.44755 1.74999 4.85331 1.75057 4.39068 1.78837ZM18.7467 20.1995C18.741 19.7866 18.7258 19.5582 18.6876 19.3659C18.4311 18.0767 17.4233 17.0689 16.134 16.8124C15.8384 16.7536 15.4653 16.75 14.5 16.75H8.5C7.53474 16.75 7.16164 16.7536 6.86596 16.8124C5.57671 17.0689 4.5689 18.0767 4.31245 19.3659C4.27421 19.5582 4.259 19.7866 4.25326 20.1995C4.70023 20.2462 5.3243 20.25 6.3 20.25H16.7C17.6757 20.25 18.2998 20.2462 18.7467 20.1995ZM11.5 5.24999C9.70507 5.24999 8.25 6.70506 8.25 8.49998C8.25 10.2949 9.70507 11.75 11.5 11.75C13.2949 11.75 14.75 10.2949 14.75 8.49998C14.75 6.70506 13.2949 5.24999 11.5 5.24999ZM6.75 8.49998C6.75 5.87663 8.87665 3.74999 11.5 3.74999C14.1234 3.74999 16.25 5.87663 16.25 8.49998C16.25 11.1233 14.1234 13.25 11.5 13.25C8.87665 13.25 6.75 11.1233 6.75 8.49998Z"
                                                fill="#89B1FF"
                                            />
                                        </svg>
                                    </div>
                                ) : (
                                    <div className="not-back"></div>
                                )}

                                <div className="border-circle">
                                    <div className="circle">
                                        {info && !fetching && (
                                            <Ava
                                                matrix={true}
                                                width="84px"
                                                height="84px"
                                                borderColor={getColor(info.relationship?.kind, info.relationship?.level)}
                                                collectionId={info.profile?.ava?.collectionId}
                                                entityId={info.profile?.ava?.entityId}
                                            />
                                        )}
                                        {shortInfo && !fetching && (
                                            <Ava
                                                matrix={true}
                                                width="84px"
                                                height="84px"
                                                borderColor={getColor(
                                                    shortInfo?.account?.relationship?.kind,
                                                    shortInfo?.account?.relationship?.level
                                                )}
                                                collectionId={shortInfo?.account?.profile?.ava?.collectionId}
                                                entityId={shortInfo?.account?.profile?.ava?.entityId}
                                            />
                                        )}
                                        {fetching && (
                                            <Ava
                                                matrix={true}
                                                width="84px"
                                                height="84px"
                                                borderColor="#0462F9"
                                                collectionId={0}
                                                entityId={0}
                                            />
                                        )}
                                    </div>
                                </div>
                                {prevPositionId && !fetching ? (
                                    <div
                                        className="icon"
                                        onClick={() => {
                                            if (fetching) return;
                                            setViewPositionId(prevPositionId);
                                            setInfo(null);
                                            setFetching(true);
                                        }}>
                                        <svg
                                            width="23"
                                            height="22"
                                            viewBox="0 0 23 22"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M6.83383 0.25H16.1662C17.0624 0.249992 17.7852 0.249985 18.3706 0.297811C18.9733 0.347054 19.5027 0.451092 19.9925 0.700647C20.7704 1.09705 21.403 1.72956 21.7994 2.50754C22.0489 2.99732 22.1529 3.52671 22.2022 4.12941C22.25 4.71476 22.25 5.43761 22.25 6.33381V15.6662C22.25 16.5624 22.25 17.2852 22.2022 17.8706C22.1529 18.4733 22.0489 19.0027 21.7994 19.4925C21.403 20.2704 20.7704 20.903 19.9925 21.2994C19.5027 21.5489 18.9733 21.6529 18.3706 21.7022C17.7852 21.75 17.0624 21.75 16.1662 21.75H6.83381C5.93761 21.75 5.21476 21.75 4.62941 21.7022C4.02671 21.6529 3.49732 21.5489 3.00754 21.2994C2.22956 20.903 1.59705 20.2704 1.20065 19.4925C0.951092 19.0027 0.847054 18.4733 0.797811 17.8706C0.749985 17.2852 0.749992 16.5624 0.75 15.6662V6.33383C0.749992 5.43763 0.749985 4.71477 0.797811 4.12941C0.847054 3.52671 0.951092 2.99732 1.20065 2.50754C1.59705 1.72956 2.22956 1.09705 3.00754 0.700647C3.49732 0.451092 4.02671 0.347054 4.62941 0.297811C5.21477 0.249985 5.93763 0.249992 6.83383 0.25ZM4.76408 1.94616C4.26366 1.98705 3.97615 2.06327 3.75837 2.17423C3.29158 2.41207 2.91207 2.79158 2.67423 3.25837C2.56327 3.47615 2.48705 3.76366 2.44616 4.26408C2.40449 4.77416 2.40385 5.42935 2.40385 6.36923V15.6308C2.40385 16.5707 2.40449 17.2258 2.44616 17.7359C2.48705 18.2363 2.56327 18.5239 2.67423 18.7416C2.91207 19.2084 3.29158 19.5879 3.75837 19.8258C3.97615 19.9367 4.26366 20.0129 4.76408 20.0538C5.27416 20.0955 5.92935 20.0962 6.86923 20.0962H16.1308C17.0707 20.0962 17.7258 20.0955 18.2359 20.0538C18.7363 20.0129 19.0239 19.9367 19.2416 19.8258C19.7084 19.5879 20.0879 19.2084 20.3258 18.7416C20.4367 18.5239 20.5129 18.2363 20.5538 17.7359C20.5955 17.2258 20.5962 16.5707 20.5962 15.6308V6.36923C20.5962 5.42935 20.5955 4.77416 20.5538 4.26408C20.5129 3.76366 20.4367 3.47615 20.3258 3.25837C20.0879 2.79158 19.7084 2.41207 19.2416 2.17423C19.0239 2.06327 18.7363 1.98705 18.2359 1.94616C17.7258 1.90449 17.0707 1.90385 16.1308 1.90385H6.86923C5.92935 1.90385 5.27416 1.90449 4.76408 1.94616ZM11.5 5.76282C11.9567 5.76282 12.3269 6.13305 12.3269 6.58974V13.4139L15.3255 10.4153C15.6485 10.0923 16.172 10.0923 16.495 10.4153C16.8179 10.7382 16.8179 11.2618 16.495 11.5847L12.0847 15.995C11.7618 16.3179 11.2382 16.3179 10.9153 15.995L6.50502 11.5847C6.18209 11.2618 6.18209 10.7382 6.50502 10.4153C6.82795 10.0923 7.35153 10.0923 7.67447 10.4153L10.6731 13.4139V6.58974C10.6731 6.13305 11.0433 5.76282 11.5 5.76282Z"
                                                fill="#89B1FF"
                                            />
                                        </svg>
                                    </div>
                                ) : (
                                    <div className="not-back"></div>
                                )}
                            </div>
                            {info && !fetching && <h3>{getLoginOrId(info)}</h3>}
                            {shortInfo && !fetching && <h3>{shortInfo.account && getLoginOrId(shortInfo.account)}</h3>}
                            {fetching && <h3></h3>}
                        </div>
                    </div>

                    <div
                        className="area1__pagination"
                        ref={pag}>
                        {positionIdList.map((el, i) =>
                            el.viewAccess ? (
                                <p
                                    onClick={() => {
                                        if (!moneyActive) return;
                                        setMoneyActive(false);
                                        setViewPositionId(el.positionId);
                                        setFetching(true);
                                        Haptick(haptic.light);
                                    }}
                                    className={`position-${el.positionId} ${viewPositionId === el.positionId ? 'active' : ''} `}
                                    key={'pag' + i}>
                                    {el.treeAccountEntityId}
                                </p>
                            ) : (
                                <p
                                    style={{ opacity: 0.5 }}
                                    key={'pag2' + i}>
                                    {el.treeAccountEntityId}
                                </p>
                            )
                        )}
                    </div>
                </div>
            </div>

            {userInfoOpen && shortInfo && (
                <Modal
                    classModal="profile-modal"
                    closeBtn={() => {
                        setUserInfoOpen(false);
                    }}>
                    <UserProfile {...shortInfo} />
                </Modal>
            )}
            {userInfoOpen && info && (
                <Modal
                    title={t('modals.profile.header.title')}
                    classModal="profile-modal"
                    closeBtn={() => {
                        setUserInfoOpen(false);
                    }}>
                    <ShortProfile
                        {...info}
                        view={true}
                    />
                </Modal>
            )}
        </>
    );
};

export default Matrix;
